var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('div',{staticClass:"drive-items-button",class:{ disabled: _vm.disabled },on:{"click":_vm.onClick}},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }